'use strict';
/* Glow Pocket — Hero scroll animation
   Section 1: 100vh static (no JS)
   Section 2: 300vh sticky columns — canvas frames 0001→0145
   Scroll formula: progress = (scrollY - heroTop) / (heroHeight - windowHeight)
   Frame index:    Math.round(progress * 144)
*/

(function () {
  var TOTAL_FRAMES = 145;

  var heroScroll = null;
  var canvas     = null;
  var ctx        = null;
  var frames     = new Array(TOTAL_FRAMES).fill(null);
  var lastFrame  = -1;
  var ticking    = false;
  var callouts   = [];
  var dpr        = 1;

  /* ── Utilities ── */
  function pad(n) {
    return String(n).padStart(4, '0');
  }

  function buildUrl(frameNum) {
    var base = heroScroll.dataset.frame1;
    return base.replace('frame_0001', 'frame_' + pad(frameNum));
  }

  /* ── Canvas sizing ── */
  function sizeCanvas() {
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    var parent = canvas.parentElement;
    var cssW   = parent ? parent.offsetWidth  : Math.round(window.innerWidth * 0.5);
    var cssH   = parent ? parent.offsetHeight : window.innerHeight;
    if (!cssW || !cssH) return;
    canvas.width  = Math.round(cssW * dpr);
    canvas.height = Math.round(cssH * dpr);
  }

  /* ── Draw with contain scaling ── */
  function drawFrame(idx) {
    if (!ctx || !canvas) return;
    var img = frames[Math.max(0, Math.min(idx, TOTAL_FRAMES - 1))];
    if (!img || !img.complete || !img.naturalWidth) return;
    var cw = canvas.width  / dpr;
    var ch = canvas.height / dpr;
    var iw = img.naturalWidth;
    var ih = img.naturalHeight;
    var scale = Math.min(cw / iw, ch / ih) * 0.9;
    var dw = iw * scale;
    var dh = ih * scale;
    var dx = (cw - dw) / 2;
    var dy = (ch - dh) / 2;
    ctx.save();
    ctx.scale(dpr, dpr);
    ctx.clearRect(0, 0, cw, ch);
    ctx.drawImage(img, dx, dy, dw, dh);
    ctx.restore();
  }

  /* ── Callout switching ── */
  function updateCallouts(progress) {
    var activeIdx = progress < 0.33 ? 0 : (progress < 0.66 ? 1 : 2);
    callouts.forEach(function (c, i) {
      if (c) c.classList.toggle('is-active', i === activeIdx);
    });
  }

  /* ── Scroll handler ── */
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var heroTop    = heroScroll.offsetTop;
      var heroHeight = heroScroll.offsetHeight;
      var winH       = window.innerHeight;
      var progress   = (window.scrollY - heroTop) / (heroHeight - winH);
      progress = Math.max(0, Math.min(1, progress));

      var frameIdx = Math.round(progress * 144);
      if (frameIdx !== lastFrame) {
        lastFrame = frameIdx;
        drawFrame(frameIdx);
      }
      updateCallouts(progress);
      ticking = false;
    });
  }

  /* ── Frame preloader ── */
  function loadFrames() {
    /* Frame 1 first — draw immediately on load, do not wait for the rest */
    var first = new Image();
    first.onload = function () {
      frames[0] = first;
      sizeCanvas();
      drawFrame(0);
    };
    first.src = buildUrl(1);
    frames[0] = first;

    /* Remaining frames in background */
    setTimeout(function () {
      for (var i = 1; i < TOTAL_FRAMES; i++) {
        (function (idx) {
          var img = new Image();
          img.onload = function () { frames[idx] = img; };
          img.src = buildUrl(idx + 1);
          frames[idx] = img;
        })(i);
      }
    }, 120);
  }

  /* ── Boot ── */
  function boot() {
    heroScroll = document.getElementById('hero-scroll');
    canvas     = document.getElementById('hero-canvas');
    if (!heroScroll || !canvas) return;

    ctx = canvas.getContext('2d');
    if (!ctx) return;

    callouts = [
      document.getElementById('hv-callout-1'),
      document.getElementById('hv-callout-2'),
      document.getElementById('hv-callout-3')
    ];

    if (callouts[0]) callouts[0].classList.add('is-active');

    loadFrames();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      sizeCanvas();
      drawFrame(lastFrame < 0 ? 0 : lastFrame);
    }, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
